import React, {} from 'react';
import {
    Card,
    Header,
    // Icon,
} from 'semantic-ui-react';
import HELPER_FUNCTION_UTILITY from '../../utils/helper';
import {formatAmountWithCurrency} from '../../utils/currency';

const LeaveBarterOption = (props) => {

    const {
        selectedOption,
        handleUpdateSelectedOption,
        currencyMinorUnit,
        currency,
    } = props;

    const {
        key,
        type,
        numOfDays,
        price,
    } = props.option;

    const isSelected = (selectedOption === key) ? true : false;

    const priceSign = (price > 0) ? '+' : (price < 0) ? '-' : '';

    // console.log('priceSign->', priceSign);
    // console.log('price->', price);

    return (
        <Card
            onClick={() => handleUpdateSelectedOption(key)}
            fluid
            style={{
                border: (isSelected) ? "2px solid #3F8CFF" : "1px solid #E5E5E5",
                borderRadius: "10px",
            }}
        >
            <Card.Content>
                <Header as="h5">
                    {(numOfDays === 0) ? 'Keep Leave Arrangement' : `${type.toUpperCase()} ${numOfDays} Day/s`}
                    <div style={{float: "right"}}>
                        {formatAmountWithCurrency(HELPER_FUNCTION_UTILITY.numberWithCommas(price >=0 ? price : price * -1, currencyMinorUnit), currency, priceSign)}
                        {/* <Icon 
                            color={(price > 0) ? "blue" : "red"}
                            name={(price > 0) ? "add circle" : "minus circle"}
                            style={{marginLeft: 5}}
                        /> */}
                    </div>
                </Header>
            </Card.Content>
        </Card>
    );
};

export default LeaveBarterOption;
